import React, {useEffect} from "react";
import './AlertThresholdsList.scss'
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as EditIcon} from "../../assets/icons/editPenIcon.svg";
import {ReactComponent as ArrowUp} from "../../assets/icons/arrowUp.svg";
import {ReactComponent as ArrowDown} from "../../assets/icons/arrowDown.svg";

const selector = state => {
    const {language, alertRules, modalState} = state;
    return {
        t: language.translator,
        pending: alertRules.pending,
        alertRules: alertRules.alertRules,
        selected: alertRules.selected,
        alertMessages: alertRules.alertMessages,
        modalState: modalState
    }
}

const AlertThresholdsList = props => {
    const {item, editMethod} = props;
    const {t} = useSelector(selector)


    return (
        <div className="AlertRulesThresholdsContainer">
            <table className={'AlertRulesThresholdsTable'}>
                <thead>
                <tr>
                    <th style={{textAlign: 'left'}} colSpan={2}>{t.gettext('Alert name')}</th>
                    <th style={{width: '60%'}}>{t.gettext('Value')}</th>
                    <th>{t.gettext('Edit')}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className={'criticalAlert'}>
                        <span>
                              {t.gettext('Critical Alert')}
                        </span>
                    </td>
                    <td>
                        <div className="firstCellWrapper">
                            <ArrowDown/>
                            <span style={{color: '#252A31'}}>
                                {t.gettext('Lower threshold')}
                            </span>
                        </div>
                    </td>
                    <td className={'criticalAlert'}>
                        {
                            item?.thresholds?.find(el => el.warningType === 'ALARM_LOW')?.value === 0
                                ? 0
                                : item?.thresholds?.find(el => el.warningType === 'ALARM_LOW')?.value || '-'
                        }
                    </td>
                    <td>
                        <div className="tableIconContainer">
                            {item.editable && (
                                <EditIcon
                                    onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'ALARM_LOW'), t.gettext('Alarm Low'), 'ALARM_LOW')}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={'standardAlert'}>
                        {t.gettext('Standard Alert')}
                    </td>
                    <td>
                        <div className="firstCellWrapper">
                            <ArrowDown/>
                            <span style={{color: '#252A31'}}>
                                {t.gettext('Lower threshold')}
                            </span>
                        </div>
                    </td>
                    <td className={'standardAlert'}>
                        {
                            item?.thresholds?.find(el => el.warningType === 'WARNING_LOW')?.value === 0
                                ? 0
                                : item?.thresholds?.find(el => el.warningType === 'WARNING_LOW')?.value || '-'
                        }
                    </td>
                    <td>
                        <div className="tableIconContainer">
                            {item.editable && (
                                <EditIcon
                                    onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'WARNING_LOW'), t.gettext('Warning Low'), 'WARNING_LOW')}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={'standardAlert'}>
                        {t.gettext('Standard Alert')}
                    </td>
                    <td>
                        <div className="firstCellWrapper">
                            <ArrowUp/>
                            <span style={{color: '#252A31'}}>
                                {t.gettext('Upper threshold')}
                            </span>
                        </div>
                    </td>
                    <td className={'standardAlert'}>
                        {
                            item?.thresholds?.find(el => el.warningType === 'WARNING_HIGH')?.value === 0
                                ? 0
                                : item?.thresholds?.find(el => el.warningType === 'WARNING_HIGH')?.value || '-'
                        }
                    </td>
                    <td>
                        <div className="tableIconContainer">
                            {item.editable && (
                                <EditIcon
                                    onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'WARNING_HIGH'), t.gettext('Warning High'), 'WARNING_HIGH')}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={'criticalAlert'}>
                        {t.gettext('Critical Alert')}
                    </td>
                    <td>
                        <div className="firstCellWrapper">
                            <ArrowUp/>
                            <span style={{color: '#252A31'}}>
                                {t.gettext('Upper threshold')}
                            </span>
                        </div>
                    </td>
                    <td className={'criticalAlert'}>
                        {
                            item?.thresholds?.find(el => el.warningType === 'ALARM_HIGH')?.value === 0
                                ? 0
                                : item?.thresholds?.find(el => el.warningType === 'ALARM_HIGH')?.value || '-'
                        }
                    </td>
                    <td>
                        <div className="tableIconContainer">
                            {item.editable && (
                                <EditIcon
                                    onClick={() => editMethod(item.thresholds?.find(el => el.warningType === 'ALARM_HIGH'), t.gettext('Alarm High'), 'ALARM_HIGH')}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}

export default AlertThresholdsList
